/**
 * Version and build information utilities
 * Provides build version, timestamp, and cache-busting functionality
 */

// These are injected at build time by Vite
export const BUILD_VERSION = import.meta.env.VITE_APP_VERSION || 'dev';
// Use a fixed timestamp in dev to prevent constant "new version" notifications
export const BUILD_TIMESTAMP = import.meta.env.VITE_BUILD_TIME || 0;

/**
 * Get formatted build version
 */
export const getBuildVersion = () => {
  return BUILD_VERSION;
};

/**
 * Get build timestamp
 */
export const getBuildTimestamp = () => {
  return BUILD_TIMESTAMP;
};

/**
 * Get formatted build date
 */
export const getBuildDate = () => {
  return new Date(BUILD_TIMESTAMP).toLocaleString();
};

/**
 * Check if a new version is available by comparing localStorage version
 */
export const checkForNewVersion = () => {
  const storedVersion = localStorage.getItem('app_version');
  const currentVersion = BUILD_VERSION;
  
  if (storedVersion && storedVersion !== currentVersion) {
    console.log(`🔄 New version detected: ${storedVersion} → ${currentVersion}`);
    return true;
  }
  
  return false;
};

/**
 * Update stored version
 */
export const updateStoredVersion = () => {
  localStorage.setItem('app_version', BUILD_VERSION);
  localStorage.setItem('app_build_timestamp', BUILD_TIMESTAMP.toString());
};

/**
 * Force reload if new version detected
 */
export const reloadIfNewVersion = () => {
  if (checkForNewVersion()) {
    console.log('🔄 Reloading to load new version...');
    updateStoredVersion();
    
    // Clear caches
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    
    // Force reload
    window.location.reload(true);
    return true;
  }
  
  // Update version on first load
  updateStoredVersion();
  return false;
};

/**
 * Get version info object
 */
export const getVersionInfo = () => {
  return {
    version: BUILD_VERSION,
    timestamp: BUILD_TIMESTAMP,
    buildDate: getBuildDate(),
    isDev: BUILD_VERSION === 'dev',
  };
};
